import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'

/**
 * SOLY-REGIE-002 — la confirmation de « Retouche gratuite ».
 *
 * Elle ne dramatise pas : elle NOMME ce qui se passe et dit qu'on peut revenir dessus. C'est la
 * sortie de ~3 % des dossiers, pas une suppression — une modale alarmante apprendrait à la lectrice
 * à s'en méfier, et donc à hésiter sur un geste parfaitement ordinaire.
 *
 * ⚠️ Modale applicative, jamais `window.confirm` : Playwright avale les dialogues natifs et le test
 * passe au vert sans que rien ne se soit produit ([[e2e_ci_traps]]).
 *
 * Partagée par les deux surfaces (fiche projet et ligne de « À facturer ») pour la même raison que
 * le hook : un seul geste ne doit pas se dire de deux façons.
 */
export function FreeTouchUpDialog({
  open,
  onOpenChange,
  onConfirm,
  isPending,
  projectName,
}: {
  open: boolean
  onOpenChange: (next: boolean) => void
  onConfirm: () => void
  isPending: boolean
  projectName?: string
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid="free-touch-up-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Retouche gratuite ?</AlertDialogTitle>
        </AlertDialogHeader>
        <AlertDialogDescription>
          {projectName ? (
            <>
              Le dossier <span className="font-medium text-foreground">{projectName}</span> sortira
              de la liste à facturer. Tu pourras revenir sur cette décision.
            </>
          ) : (
            <>Ce dossier sortira de la liste à facturer. Tu pourras revenir sur cette décision.</>
          )}
        </AlertDialogDescription>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isPending}>Annuler</AlertDialogCancel>
          <AlertDialogAction
            data-testid="free-touch-up-confirm"
            disabled={isPending}
            onClick={(e) => {
              // Le dialogue se ferme tout seul sur Action ; on garde la main pour que l'appelant
              // décide quand rafraîchir, sinon la liste se recharge avant la fin de l'appel.
              e.preventDefault()
              onConfirm()
            }}
          >
            {isPending ? 'Enregistrement…' : 'Retouche gratuite'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
